module.exports = __webpack_public_path__ + "img/ic_word.ec79b5fd.png";